import React from 'react';

import PhotoSelectorContextProvider from '../../../components/global/PhotoSelectorContext';
import AlbumManualMatching from '../../../apps/pro/views/Album/AlbumPhotos/components/AlbumManualMatching/AlbumManualMatching';

const AlbumManualMatchingView = () => {
  return (
    <PhotoSelectorContextProvider>
      <AlbumManualMatching headerless />
    </PhotoSelectorContextProvider>
  );
};

export default AlbumManualMatchingView;
